import { useEffect, useRef } from "react";

export default function useDidMountEffect(effect, deps) {
  const didMount = useRef(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => didMount.current ? effect() : didMount.current = true, deps);
}
